import { render, staticRenderFns } from "./ChildrenList.vue?vue&type=template&id=7092de62"
import script from "./ChildrenList.vue?vue&type=script&lang=js"
export * from "./ChildrenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports